import { CCManagerReportsData } from './CCManagerReportData';

export default class CcManagerReportsSelector {
  public static selectMessage(state: ReduxState): CCManagerReportsData {
    return state.ccManagerReport.data;
  }
}
